

import { Component, Vue } from 'vue-property-decorator';
import { CartState } from '@/store/types';

@Component({
  components: {
  },
})
export default class VueBase extends Vue {
  get cartState(): CartState {
    return this.$store.state.carts;
  }
}
